import * as React from 'react';

import PaymentsSubscription from '../containers/PaymentsSubscription';

function SubscriptionWrapper() {

  const [open, setOpen] = React
    .useState(false);

  const handleClickOpen = React
    .useCallback(() => setOpen(true), []);

  const handleClose = React
    .useCallback(() => setOpen(false), []);

  return(
    <div className='payments-head-text'>
      <button
        onClick={handleClickOpen}
        className='payments-add-subscription'>
        {'Open'}
      </button>
      <PaymentsSubscription
        open={open}
        onClose={handleClose} />
    </div>
  );
}

export default SubscriptionWrapper;
